export var parseISODate = function (stringDate) {
    var parts = stringDate.match(/^(\d{4})-[\xA0 ]?(\d{1,2})-[\xA0 ]?(\d{1,2})$/);
    if (parts === null) {
        return null;
    }
    var year = Number(parts[1]);
    var month = Number(parts[2]) - 1;
    var day = Number(parts[3]);
    var date = new Date(year, month, day);
    return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day ? date : null;
};
